/*eslint default-case: 0*/

export default (state = {}, { type }) => {
    switch(type){
        case "SET-INTERNAL-VIEWED": {
            return { ...state, internalPageViewed: true };
        }
    }
    return state;
};